export default __webpack_public_path__ + "static/GT-Walsheim-Regular-c4f8cd159d7a3284b5e2904d6b283e1b.woff2";